import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';

import { Link as RouterLink } from 'react-router-dom';
import voybusLogo from '../assets/voybus-logo.svg';

function Header() {
  const pages = [
    { label: 'Home', route: '/' },
    { label: 'Paquetes', route: '/paquetes' },
    { label: 'Destinos', route: '/destinos' },
    { label: 'Alojamientos', route: '/alojamientos' },
    { label: 'Quienes Somos', route: '/quienes-somos' },
  ];

  // Estado para anclar el menú (mobile)
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar
      position="static"
      color="default"
      elevation={0}
      sx={{ backgroundColor: '#fff' }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>

          {/* LOGO - se muestra siempre (sin distinción de tamaño) */}
          <Box
            component={RouterLink}
            to="/"
            sx={{ display: 'flex', mr: 2 }}
          >
            <Box
              component="img"
              src={voybusLogo}
              alt="Logo"
              sx={{ height: 75 }}
            />
          </Box>

          {/* === MENÚ DESKTOP === */}
          {/* Oculto en móvil (xs), visible en md en adelante */}
          <Box 
            sx={{ 
              flexGrow: 1, 
              display: { xs: 'none', md: 'flex' }, 
              justifyContent: 'flex-end' 
            }}
          >
            {pages.map(({ label, route }) => (
              <Button
                key={label}
                component={RouterLink}   // Enlaza con React Router
                to={route}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, display: 'block' }}
              >
                {label}
              </Button>
            ))}
          </Box>

          {/* === MENÚ MOBILE (ICONO HAMBURGUESA) === */}
          {/* Visible en xs, oculto en md+ */}
          <Box sx={{ display: { xs: 'flex', md: 'none' }, ml: 'auto' }}>
            <IconButton
              size="large"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>

            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
            >
              {pages.map(({ label, route }) => (
                <MenuItem 
                  key={label} 
                  component={RouterLink} 
                  to={route} 
                  onClick={handleCloseNavMenu}
                >
                  <Typography textAlign="center">{label}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Header;
